/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsOilDropletCheck: {
  name: 'oil-droplet-check';
  data: string;
} = {
  name: 'oil-droplet-check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.357 2.234a1 1 0 0 1 1.286 0 19.177 19.177 0 0 1 3.165 3.374 1 1 0 1 1-1.616 1.179A16.981 16.981 0 0 0 12 4.332C8.41 7.652 7 11.697 7 14.7c0 2.974 2.284 5.3 5 5.3s5-2.326 5-5.3a1 1 0 1 1 2 0c0 3.985-3.089 7.3-7 7.3s-7-3.315-7-7.3c0-3.783 1.851-8.68 6.357-12.466ZM10 14a1 1 0 0 1 1 1 1 1 0 0 0 1 1 1 1 0 1 1 0 2 3 3 0 0 1-3-3 1 1 0 0 1 1-1Zm10.707-6.293a1 1 0 0 0-1.414-1.414L15 10.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l5-5Z" fill="currentColor"/></svg>`,
};
